import { FaTerminal } from "react-icons/fa";
import { CommandsViewMain } from "../Components/CommandsViewMain";

export const CommandsModule = () => [
    {
        views: "PRIVATE",
        path: "/commands",
        component: <CommandsViewMain />,
        roles: null,
        permissions: null,
        label: "Comandos",
        icon: <FaTerminal />,
        displayInHeader: false,
        displayInFooter: false,
        displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
];
